import React from 'react'
import App from './App.jsx'
import Home from './components/home.jsx'
import Code from './components/code.jsx'
import Blog from './components/blog.jsx'
import Projects from './components/projects.jsx'
import GalleryPage from './components/galleryPage.jsx'
import NotFound from './components/notfound.jsx'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { withRouter, Redirect } from "react-router"

class AppRouter extends React.Component {

  components = {
    home: Home,
    code: Code,
    projects: Projects,
    gallery: GalleryPage, 
    blog: Blog
  }
  applications = {
    default: App
  }

  RoutedApp = withRouter(this.applications[this.props.application])

  is404Redirect = () => {
    return /page=(\w+)/.test(document.location.search)
  }
  requestedPageIsValid = () => {
    const match = document.location.search.match(/page=(\w+)/)
    return match[1] in this.components
  }
  getPathFromQueryString = () => {
    
    //todo: install qs and use that.
    var page = document.location.search.match(/page=(\w+)/)[1]
    if(/id=([\w+-])+/.test(document.location.search)){
      var id = document.location.search.match(/id=([\w-]+)/)[1]
      return page + "?id=" + id
    }
    return page
  }

  routes = () => {

    return (
      <Switch>
        <Route exact path="/" render={() => (
          this.is404Redirect() && this.requestedPageIsValid() ? (
            <Redirect to={this.getPathFromQueryString()} />
          ) : (
              <Home />
            )
        )} />
        <Route exact path='/code' component={Code} />
        <Route path='/gallery' component={GalleryPage} />
        <Route exact path='/projects' component={Projects} />
        <Route path='/blog' component={Blog} />
        <Route component={NotFound} />
      </Switch>
    )
  }
  componentDidMount = () => {

    window.addEventListener('popstate', (event) => {
      //console.log("POPSTATE: location: " + document.location + ", state: " + JSON.stringify(event.state));
    });
  }
  render = () => {
    return (
      
        <Router>
          <this.RoutedApp>
            {this.routes()}
          </this.RoutedApp>
        </Router>

    );
  }

}

export default AppRouter;
